module.exports = __webpack_public_path__ + "img/persona-5.0fbc11ba.png";